import React, { useContext } from 'react';
import RiskOverviewStandardSectionHeader from '/src/Components/RiskOverviewStandardSectionHeader/RiskOverviewStandardSectionHeader';
import { ClipboardList, MousePointerClick, Laugh } from 'lucide-react';
import CTAButton from '/src/Components/CTAButton/CTAButton';
import { WindowSizeContext } from '/src/App';


import './style.css';

const About = ({ handleAboutComplete, propertyData, subsections }) => {

    const { deviceType } = useContext(WindowSizeContext);

    const projects = propertyData?.data?.recommended_projects?.projects_list || [];
    const num_projects = projects.length;


    const header = "Take a Deep Breath...."
    const subheader = `Building resilience is a process and nobody expects you to immediately act on the recommended improvements. We're here to support your journey, with tools to help you make informed decisions and act on them. It's ok to feel overwhelmed, take as long as you need for each step. You've got this!`
    const buttonText = "Let's get started!"


    const main_sections = [
        {
            id: '1',
            label: 'Selecting the Right Projects For You',
            description: "Let's fill in the remaining gaps!",
            icon: 'fact-finding-stage-icon-light.png',

        },
        {
            id: '2',
            label: 'Making a Plan',
            description: 'Skip overwhelmed and jump right to prepared!',
            icon: 'planning-stage-icon-light.png',

        },
        {
            id: '3',
            label: 'Getting Improvements Done',
            description: "Ready to go? Let's capture all of those incentives!",
            icon: 'taking-action-stage-icon-light.png',

        },
    ]

    return (
        <div className={`taking-action-about-container ${deviceType}`}>
            <RiskOverviewStandardSectionHeader title={header} />

            <div className={`taking-action-about-sections ${deviceType}`}>
                {/* Main Sections */}
                <div className={`taking-action-about-main-sections ${deviceType}`}>
                    {main_sections.map((section) => (
                        <div key={section.id} className="taking-action-about-individual-item">

                            <div className="taking-action-about-individual-item-step-number">
                                <span>Step {section.id}</span>
                            </div>
                            <div key={section.id} className="taking-action-about-header">
                                <div className="taking-action-about-icon-wrapper big">

                                    {section.id === '1' && <MousePointerClick />}
                                    {section.id === '2' && <ClipboardList />}
                                    {section.id === '3' && <Laugh />}

                                    {/* <img
                                    src={CreateCloudfrontUrl(section.icon)}
                                    alt={section.label}
                                    /> */}
                                </div>
                                <span className='text-align-center'>{section.label}</span>
                            </div>
                        </div>
                    ))}
                </div>
                <p className="text-align-center">{subheader}</p>

                {/* Single Curly Brace */}
                {/* <CurlyBraceDivider /> */}

                {/* Subsections */}
                {/* <div className="taking-action-about-all-subsections">
                    {subsections.map((subsection) => (
                        <div key={subsection.id} className="taking-action-about-subsection">
                            <div className="taking-action-about-subsection-header">
                                <div className="taking-action-about-icon-wrapper">
                                    <img
                                        src={CreateCloudfrontUrl(subsection.icon_green)}
                                        alt={subsection.label}
                                    />
                                </div>
                                <span className="taking-action-about-subsection-header-title text-align-center">{subsection.label}</span>
                            </div>
                        </div>
                    ))}
                </div> */}
            </div>

            <CTAButton text={buttonText} onClick={handleAboutComplete} />
        </div>
    );
};

export default About;